module.exports = __webpack_public_path__ + "img/Footer_HQ.d1337c41.png";